export const SIZE_MAP: {[key: string]: number} = {
  xsmall: 18,
  small: 24,
  medium: 32,
  large: 48,
  xlarge: 48,
};

export const STROKE_WIDTH_MAP: {[key: string]: number} = {
  18: 2.5,
  24: 2.5,
  32: 3,
  48: 4,
};
